import queryClient from "./query";
import {disconnect as disconnectSocket, socket} from "./socket";
import {setGlobalState} from "./store";
import {portalConfig} from "portal";
const axios = require("axios");
const token = window.localStorage.getItem(process.env.REACT_APP_KEY);
// export const socket = io.connect("http://localhost:3000/consultas_online");
 


// export const socket = io("http://localhost:3000/consultas_online");

let instance = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	timeout: 120000,
});
instance.interceptors.request.use(
	config=>{
		const t = window.localStorage.getItem(process.env.REACT_APP_KEY);
		config.headers.Authorization = `Bearer ${t}`;
		config.headers["X-Transportista-Portal"] = portalConfig.tipoOperacion;
		if(socket.connected && socket.id) config.headers["X-Socket-ID"] = socket.id;
		return config;

	}
)
export function init(token){
	instance.defaults.headers["Authorization"] = `Bearer ${token}`;
}

export const Authorization = `Bearer ${token}`;
export function externalGet(uri){
	return new Promise((resolve, reject)=>{
		axios.get(uri).then(function (response) {
			resolve(response.data);
		}).catch(function (error) {
			if (error?.response?.status === 408 || error?.code === "ECONNABORTED") {
				reject("Por favor revisa tu conexión a internet");
			}
			return reject({errmsg: error.response?.data.error || error.message, errcode:error?.response?.status});
		});
	});
}
export function get(uri, params){
	return new Promise((resolve, reject)=>{
		instance.get(uri,{params}).then(function (response) {
			resolve(response.data);
		}).catch(function (error) {
			if (error?.response?.status === 408 || error?.code === "ECONNABORTED") {
				reject("Por favor revisa tu conexión a internet");
			}
			return reject({errmsg: error.response?.data.error || error.message, errcode:error?.response?.status});
		});
	});
}

export function post(uri, data, options){
	return new Promise((resolve, reject)=>{
		instance.post(uri, data, options).then(function (response) {
			resolve(response.data);
		}).catch(error=>{
			if (error?.response?.status === 408 || error?.code === "ECONNABORTED") {
				reject("Por favor revisa tu conexión a internet");
			}
			return reject({errmsg: error.response?.data.error || error.message, errcode:error?.response?.status, code:error?.response?.data?.code});
		});
	});
}
export function put(uri, data){
	return new Promise((resolve, reject)=>{
		instance.put(uri, data).then(function (response) {
			resolve(response.data);
		}).catch(function (error) {
			if (error?.response?.status === 408 || error?.code === "ECONNABORTED") {
				reject("Por favor revisa tu conexión a internet");
			}
			return reject({errmsg: error.response?.data.error || error.message, errcode:error?.response?.status});
		});
	});
}
export function remove(uri, data){
	return new Promise((resolve, reject)=>{
		instance.delete(uri, data).then(function (response) {
			resolve(response.data);
		}).catch(function (error) {
			if (error?.response?.status === 408 || error?.code === "ECONNABORTED") {
				reject("Por favor revisa tu conexión a internet");
			}
			return reject({errmsg: error.response?.data.error || error.message, errcode:error?.response?.status});
		});
	});
}
export function upload(uri, files){
	return new Promise((resolve, reject)=>{
		// const url = 'http://localhost:3000/patients/img';
		const formData = new FormData();
		if(Array.isArray(files)){
			files.forEach(f => {
				formData.append(f.name,f.file);
			});
		}
		const config = {
			headers: {
				"content-type": "multipart/form-data"
			},
			timeout:180000
		};
		instance.post(uri, formData, config).then(function (response) {
			resolve(response.data);
		}).catch(function (error){
			if (error?.response?.status === 408 || error?.code === "ECONNABORTED") {
				reject("Por favor revisa tu conexión a internet");
			}
			return reject(error.response?.data.error || error.message);
		});
	}); 
}
export const track = console.log
export const login = (data) => post("/transportista-login",data, { withCredentials: true });
export const logout = () => {
	console.log("LOGGING OUT")
	disconnectSocket();

	// setGlobalState("loggedIn",false)
	instance.defaults.headers["Authorization"] = null;

	queryClient.resetQueries()

	queryClient.removeQueries();
	queryClient.invalidateQueries();
	return post("/cliente-logout");
}
export const getCartaPorte = () => axios.get("/carta_porte.json");
export const aceptarSolicitud = (data) =>  post(`/solicitudes/${data.id_solicitud}/aceptar`,data, { withCredentials: true });
export const rechazarSolicitud = (id_solicitud) =>  post(`/solicitudes/${id_solicitud}/rechazar`, { withCredentials: true });
export const getSolicitudesPortuarias = () => get("/solicitudes/portuarias");
export const tomarSolicitudPortuaria = (id_solicitud) => post(`/solicitudes/portuarias/${id_solicitud}/tomar`, {});
export const rechazarSolicitudPortuaria = ({id_solicitud, motivo}) => post(`/solicitudes/portuarias/${id_solicitud}/rechazar`, {motivo});
export const registro = (data) => post("/transportista-registro",data, { withCredentials: true });
export const getTiposUnidad = () => get("/tipos-unidad");
export const getTiposMercancia = () => get("/tipos-mercancia");
export const getViajes = (data) => get("/clientes/me/viajes")
export const getConsolidado = (id) => get(`/viajes-consolidados/${id}`)
export const getDedicado = (id) => get(`/transportistas/me/viajes/${id}`)
export const setFechaPagoViaje = ({id, dias}) => post(`/transportistas/me/viajes/${id}/fecha-pago`,{dias})

export const getUser =(id) => get(`/transportistas/me`)
export const getCustomer = () => get(`/transportistas/me`)

export const getUsers =(id) => get(`/transportistas/me/usuarios`)
export const getHome =(id) => get(`/transportistas/me/home`);
export const getViaje = ({queryKey}) => get(`/transportistas/me/viajes/${queryKey[1]}`);
export const getViajesPortuarios = () => get(`/transportistas/me/viajes-portuarios`, {all:true});
export const getViajePortuario = ({queryKey}) => get(`/transportistas/me/viajes-portuarios/${queryKey[1]}`);
export const asignarViajePortuario = ({id, ...data}) => post(`/transportistas/me/viajes-portuarios/${id}/asignar`, data);
export const cargarCartaPortePortuaria = ({id, file}) => upload(
	`/transportistas/me/viajes-portuarios/${id}/carta-porte`,
	[{name: "documentos.carta_porte.archivo", file}],
);
export const enviarFacturaPortuaria = ({id, metodo_cobro, xml, pdf, banco, clabe}) => {
	const formData = new FormData();
	formData.append("metodo_cobro", metodo_cobro);
	formData.append("banco", banco);
	formData.append("clabe", clabe);
	formData.append("facturacion_transportista.factura.xml", xml);
	formData.append("facturacion_transportista.factura.pdf", pdf);
	return post(`/transportistas/me/viajes-portuarios/${id}/facturacion`, formData, {timeout: 180000});
};
export const cambiarConductor = (idViaje, id_conductor) => post(`/transportistas/me/viajes/${idViaje}/cambiar-conductor`,{id_conductor});
export const cambiarUnidad = (idViaje, id_unidad) => post(`/transportistas/me/viajes/${idViaje}/cambiar-unidad`,{id_unidad});

export const cotizarSeguro = (data) => post("/transportistas/me/seguros/cotizar", data);
export const crearSeguro = (data) => post("/transportistas/me/seguros", data);
export const finalizarSeguro = (idSeguro, id_transportista) => post(`/transportistas/me/seguros/${idSeguro}/finalizar-pago`,{id_transportista});
export const reportarSiniestro = (idSeguro, siniestroData) => post(`/transportistas/me/seguros/${idSeguro}/reportar-siniestro`, siniestroData);

export const getTrygerLocations = (cp, country=1) => externalGet(`${process.env.REACT_APP_TRYGER_ENDPOINT}/chubb/location?zipCode=${cp}&countryId=${country}`);
export const getTrygerAssets = () => externalGet(`${process.env.REACT_APP_TRYGER_ENDPOINT}/assets`);
export const getTrygerCountries = () => externalGet(`${process.env.REACT_APP_TRYGER_ENDPOINT}/countries`);
export const postInsuranceLead = (data) => post(`/seguros-lead`, data);

export const postConsolidado = (data) => post("/viajes-consolidados",data)
export const postDedicado = (data) => post("/viajes-dedicados",data)
export const postProyecto = (data) => post("/proyectos",data)
export const getCliente = () => get("/clientes/me")
export const postCustomerCard = ({token}) => post("/clientes/me/cards", {token})
export const getCustomerCards = () => get("/clientes/me/cards")
export const pagarViajeDedicado = ({idViaje, cardId}) => post(`/viajes-dedicados/${idViaje}`, {cardId})
export const cotizarViajeDedicado = (data) => post(`/cotizar`, data);

export const crudFunctions = (type, replacements) => {
	const tipo = type.url;
	return {
		getAll: ()=>{
			return get(`/${tipo}`);
		},
		getOne: (id)=>{
			return get(`/${tipo}/${id}`);
		},
		getPaginated: ({queryKey})=>{
			console.log({queryKey},{page:queryKey[1].page, search:queryKey[1].filter, sort:queryKey[1].sort})
			return get(`/${tipo}`,{page:queryKey[1].page, search:queryKey[1].filter, sort:queryKey[1].sort});
		},
		insert:async ({files, ...data})=>{
			const response = await post(`/${tipo}`, data);
			if(files){
				const r = await upload(`/${tipo}/${response.data._id}/files`, files);
				return r;
			}
		},
		update:async (id, {files, ...data})=>{
			await put(`/${tipo}/${id}`, data);
			if(files){
				const r = await upload(`/${tipo}/${id}/files`, files);
				return r;
			}
		},
		trash:(id)=>{
			return put(`/${tipo}/${id}`, {_trash: true});
		},
		untrash:(id)=>{
			return put(`/${tipo}/${id}`, {_trash: false});
		},
		delete:(id)=>{
			return remove(`/${tipo}/${id}`);
		},
		...replacements
	};
};


export default {post, get, put, remove, upload, init};
